// extracted by mini-css-extract-plugin
export default {"imgBox":"HGRj26StbTLSq002Rck9"};